import { writable, derived } from 'svelte/store';
import type { Language } from './config';
import { defaultLanguage, languageConfig } from './config';

// Current language store
export const currentLanguage = writable<Language>(defaultLanguage);

// Derived store for language configuration
export const currentLanguageConfig = derived(currentLanguage, ($lang) => languageConfig[$lang]);
